



































import PassengerTransportationPermission from '@/views/PassengerTransportationPermission.vue';
import {Vue, Prop, Component, Watch} from 'vue-property-decorator';
@Component({
    components: {
      PassengerTransportationPermission
    }
})
export default class TransportationPermissionListItem extends Vue {
  @Prop({required: true}) permission!: IBookingQuotaWithPeriods;

  viewPermissionDialog: boolean = false;
  @Watch("viewPermissionDialog")
  viewPermissionDialogChanged(newValue: boolean) {
    if (newValue) {
      this.$nextTick(() => {
        const dialog = this.$refs?.viewPermissionDialogRef as Vue | undefined;
        const content = dialog?.$refs?.content as HTMLElement | undefined;
        if (content && dialog && dialog.$attrs) {
          // Copy aria-labelledby from v-dialog to new rendered element.
          content.setAttribute('aria-label', dialog.$attrs['aria-label']);
          const innerVDialog = content.querySelector('.v-dialog');
          if (innerVDialog) {
            innerVDialog.removeAttribute('tabindex');
          }
        }
      });
    }
  }

  get startDate() {
    if (this.permission) {
        return this.$moment(this.permission.startDate).format('DD.MM.YYYY');
    } 
    return '';
  }

  get endDate() {
    if (this.permission && this.permission.endDate) {
        return this.$moment(this.permission.endDate).format('DD.MM.YYYY');
      } 
    return '';
  }

}
